/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts () {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  webFontLoader.load({
    google: {
      families: ["Noto Sans TC:100,300,400,500,700","Michroma:400","Open Sans:300,400,500,600,700","Poppins: 400"],
    },
  })
}
